import { GUEST_FILTER } from '@pages/event/api/useFetchTicketSegment';
import { Button } from '@shared/ui/kit';
import * as stylex from '@stylexjs/stylex';
import { styles } from './styles';

interface GuestListFilterProps {
  guestFilter: string | null;
  onChange: (value: string | null) => void;
}

export const GuestListFilter = ({ guestFilter, onChange }: GuestListFilterProps) => (
  <div {...stylex.props(styles.guestListFilter)}>
    <Button size="small" variant={guestFilter ? 'secondary' : 'primary'} onClick={() => onChange(null)}>
      Любой
    </Button>

    <Button
      size="small"
      variant={guestFilter === GUEST_FILTER.NOT_ALONE ? 'primary' : 'secondary'}
      onClick={() => onChange(GUEST_FILTER.NOT_ALONE)}
    >
      Не один
    </Button>

    <Button
      size="small"
      variant={guestFilter === GUEST_FILTER.WITHOUT_CHILDREN ? 'primary' : 'secondary'}
      onClick={() => onChange(GUEST_FILTER.WITHOUT_CHILDREN)}
    >
      Без детей
    </Button>

    <Button
      size="small"
      variant={guestFilter === GUEST_FILTER.WITH_CHILDREN ? 'primary' : 'secondary'}
      onClick={() => onChange(GUEST_FILTER.WITH_CHILDREN)}
    >
      С детьми
    </Button>
  </div>
);
